/**
 * @generated SignedSource<<00991a1eed811e83f9015c0764b0824d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getSelectedOptions$data = {
  readonly edges: ReadonlyArray<{
    readonly fieldSets: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __id: string;
          readonly fields: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly __typename: string;
                readonly __id: string;
                readonly fieldId: string;
                readonly fieldOption?: {
                  readonly optionId: string;
                } | null | undefined;
                readonly selectedOptions?: {
                  readonly edges: ReadonlyArray<{
                    readonly __id: string;
                    readonly node: {
                      readonly id: string;
                      readonly value: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly type: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "getSelectedOptions";
};
export type getSelectedOptions$key = {
  readonly " $data"?: getSelectedOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"getSelectedOptions">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getSelectedOptions"
};

(node as any).hash = "d834d874b11bf040e4a6fed6a2824cab";

export default node;
